<template>
  <a
    :href="href"
    :class="classes"
    :target="hasTarget"
    :rel="hasRel"
    class="link"
    @click="handleClick($event)"
  >
    <slot />
  </a>
</template>

<script>
export default {
  name: 'KfLink',
  props: {
    href: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    target: {
      type: String,
      default: '',
    },
  },
  computed: {
    iconType() {
      return this.type === 'download' || this.type === 'external';
    },
    classes() {
      return {
        [`is-${this.type}`]: this.type,
      }
    },
    hasTarget() {
      return this.target ? '_blank' : null;
    },
    hasRel() {
      return this.target ? 'noopener noreferrer' : null;
    },
  },
  methods: {
    handleClick(e) {
      this.$emit('handleClick', e);
    },
  }
};
</script>
